import styled from 'styled-components';
import { FaFeatherAlt } from 'react-icons/fa';

export const HeaderContainer = styled.header`
  background-color: #4a90e2;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const Title = styled.h1`
  color: white;
  font-size: 28px;
  margin-left: 12px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

export const Icon = styled(FaFeatherAlt)`
  color: white;
  font-size: 28px;
`;
